// extracted by mini-css-extract-plugin
module.exports = {"card":"az_mZb","headerText":"az_nZb","divider":"az_oZb"};